import axios from 'axios';
import qs from 'qs';
import { Toast } from '../components/Toast/Toast';
var baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = ''
} else {
  baseURL = '//zp.58.com/'
}

const ax = axios.create({
  baseURL,
  timeout: 5000,
  withCredentials: true,//允许携带cookie
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})
const apiUrl = {
  //接口
  recommendTabList: '/yy/2021/magic/special/guessdata',
  recommendJobList: '/yy/2021/magic/special/infolist',
  livingData: '/yy/2021/magic/special/subjectdata',
  checkInList: "/yy/2021/magic/signin/list",
  checkIn: "/yy/2021/magic/signin/insert",
  brandEmployer: '/yy/2021/magic/special/subjectdata',
  address: '/yy/2021/magic/signin/address',
  haveResume: '/yy/2021/magic/signin/haveResume',
}

export const requestGet = (urlStr, data) => {
  var url = apiUrl[urlStr];
  if (!data) {
    data = null;
  }
  return ax.get(url, { params: data })
    .then((res) => {
      return res.data
    })
    .catch(err => {
      console.log(`${url}接口请求失败，错误信息为：${err}`)
    })
}

export const requestPost = (urlStr, data) => {
  var url = apiUrl[urlStr];
  return ax.post(apiUrl[urlStr], qs.stringify(data))
    .then((res) => {
      return res.data
    })
    .catch(err => {
      console.log(`${url}接口请求失败，错误信息为：${err}`)
    })
}
